import React, { useState } from "react";
import "./Btg.css";

// Images
import logo from "./assets/BTG-cropped.png";
import assetLogo from "./assets/AM dark logo.png";
import heroImg from "./assets/heroImg.jpg";
import introImg from "./assets/14.jpg";
import aboutImg1 from "./assets/15.jpg";
import aboutImg2 from "./assets/16.jpg";
import gallery1 from "./assets/3.jpg";
import gallery2 from "./assets/9.jpg";
import gallery3 from "./assets/5.jpg";
import gallery4 from "./assets/6.jpg";
import gallery5 from "./assets/7.jpg";
import gallery6 from "./assets/8.jpg";
import gallery7 from "./assets/4.jpg";
import gallery8 from "./assets/10.jpg";
import gallery9 from "./assets/11.jpg";
import locationMap from "./assets/BTG-map.png";

import masterPlan from "./assets/2.jpg";


const Btg = () => {
    const [formData, setFormData] = useState({
  name: "",
  phone: "",
  email: "",
  interested: "",
  message: "",
});

const handleChange = (e) => {
  const { name, value } = e.target;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));
};

const handleSubmit = (e) => {
  e.preventDefault();

  console.log(formData);

 // alert("Enquiry Submitted");
};

  return (
    <main className="btg-page">

      {/* ================= HEADER ================= */}

      <header className="btg-header">

        <a
          href="/"
          className="btg-header__logo"
          aria-label="Between The Greens"
        >
          <img
            src={logo}
            alt="Between The Greens"
          />
        </a>

        <div className="btg-header__contact">
          <span>Call For Site Visit</span>

          <a href="tel:+919243024730">
            +91 92430 24730
          </a>
        </div>

        <a
          href="/"
          className="btg-header__logo"
          aria-label="Asset Makers"
        >
          <img
            src={assetLogo}
            alt="Asset Makers"
          />
        </a>

      </header>

      {/* ================= HERO ================= */}

      <section className="btg-hero-visual">

        <img
          src={heroImg}
          alt="Between The Greens Villa Community"
        />

        <div className="btg-hero-visual__overlay"></div>

        <div className="btg-hero-visual__content">

          <p>
            Premium 4 BHK Villas In Varthur, Whitefield
          </p>

          <h1>
            Between The Greens
          </h1>

          <a
            href="#enquire"
            className="btg-btn btg-btn--light"
          >
            Book A Site Visit
          </a>

        </div>

      </section>

      {/* ================= HIGHLIGHTS ================= */}

      <section className="btg-highlights">

        <div className="btg-highlight">
          <span>Project Type</span>
          <strong>4 BHK Villas</strong>
          <p>Premium Villa Community</p>
        </div>

        <div className="btg-highlight">
          <span>Location</span>
          <strong>Varthur</strong>
          <p>Whitefield, Bengaluru</p>
        </div>

        <div className="btg-highlight">
          <span>Land Parcel</span>
          <strong>9.5 Acres</strong>
          <p>Low-density Living</p>
        </div>

        <div className="btg-highlight">
          <span>Total Villas</span>
          <strong>137</strong>
          <p>Exclusive Residences</p>
        </div>

        <div className="btg-highlight">
          <span>Villa Sizes</span>
          <strong>3471–3857 Sq. Ft.</strong>
          <p>Selected Configurations</p>
        </div>

        <div className="btg-highlight">
          <span>Status</span>
          <strong>Ongoing</strong>
          <p>BDA Approved</p>
        </div>

      </section>

      {/* ================= INTRO ================= */}

<section className="btg-video-section">
    <div className="btg-video-container">
        <iframe
            src="https://www.youtube.com/embed/TNp6-R3hPmo"
            title="Between The Greens Luxury Villas"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            allowFullScreen
        />
    </div>
</section>

    <section className="btg-intro" id="enquire">

        <div className="btg-intro__media">

            <img
                src={introImg}
                alt="Between The Greens"
            />

        </div>

      

        <div className="btg-intro__content">

            <p className="btg-eyebrow">
                Luxury Villas By 42 Estates
            </p>

            <h2>
                Life Between Architecture,
                Privacy And Open Greens.
            </h2>

            <p>
                Between The Greens is an exclusive villa enclave
                in Varthur, Whitefield, designed for families
                who value space, greenery, privacy and refined
                community living.
            </p>

            <p>
                Spread across 9.5 acres with 137 premium
                villas, elegant architecture,
                landscaped greens and thoughtfully
                planned amenities.
            </p>

            <div className="btg-form-card">

                <h3>
                    Request A Callback
                </h3>

                <form onSubmit={handleSubmit}>

                    <div className="btg-field">

                        <input
                            type="text"
                            name="name"
                            placeholder="Your Full Name"
                            value={formData.name}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="btg-field">

                        <input
                            type="tel"
                            name="phone"
                            placeholder="Mobile Number"
                            value={formData.phone}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="btg-field">

                        <input
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={formData.email}
                            onChange={handleChange}
                        />

                    </div>

                    <div className="btg-field">

                        <select
                            name="interested"
                            value={formData.interested}
                            onChange={handleChange}
                        >

                            <option value="">
                                Interested In
                            </option>

                            <option>
                                4 BHK West Villa
                            </option>

                            <option>
                                4 BHK East Villa
                            </option>

                            <option>
                                4 BHK Villa With Backyard
                            </option>

                            <option>
                                Site Visit
                            </option>

                            <option>
                                Price Details
                            </option>

                        </select>

                    </div>

                    <div className="btg-field">

                        <textarea
                            name="message"
                            placeholder="Your Message"
                            value={formData.message}
                            onChange={handleChange}
                        />

                    </div>

                    <button
                        className="btg-btn btg-btn--dark"
                    >
                        Send Enquiry
                    </button>

                </form>

                <p className="btg-form-card__note">

                    Or call Asset Makers directly at

                    <a href="tel:+919243024730">
                        +91 92430 24730
                    </a>

                </p>

            </div>

        </div>

    </section>

{/* ================= ABOUT ================= */}

<section className="btg-section btg-about">

    <div className="btg-section__head">

        <p className="btg-eyebrow">
            About The Project
        </p>

        <h2>
            Premium Villa Living
            In The Heart Of
            East Bengaluru.
        </h2>

    </div>

    <div className="btg-about__grid">

        <div className="btg-about__text">

            <p>

                Designed as a private villa community,
                Between The Greens focuses on natural light,
                greenery and open spaces.

            </p>

            <p>

                Located close to Whitefield,
                IT Parks, schools,
                hospitals and shopping destinations.

            </p>

            <div className="btg-stats">

                <div>

                    <strong>
                        9.5
                    </strong>

                    <span>
                        Acres
                    </span>

                </div>

                <div>

                    <strong>
                        137
                    </strong>

                    <span>
                        Villas
                    </span>

                </div>

                <div>

                    <strong>
                        4
                    </strong>

                    <span>
                        BHK Villas
                    </span>

                </div>

                <div>

                    <strong>
                        BDA
                    </strong>

                    <span>
                        Approved
                    </span>

                </div>

            </div>

        </div>

        <div className="btg-about__images">

            <img
                src={aboutImg1}
                alt=""
            />

            <img
                src={aboutImg2}
                alt=""
            />

        </div>

    </div>

</section>

{/* ================= GALLERY ================= */}

<section className="btg-section btg-section--soft">

    <div className="btg-section__head">

        <p className="btg-eyebrow">
            Project Gallery
        </p>

        <h2>
            Spaces Made For Calm,
            Comfort And Everyday Luxury.
        </h2>

    </div>

    <div className="btg-gallery">

        <img src={gallery1} alt="" />
        <img src={gallery2} alt="" />
        <img src={gallery3} alt="" />
        <img src={gallery4} alt="" />
        <img src={gallery5} alt="" />
        <img src={gallery6} alt="" />
        <img src={gallery7} alt="" />
        <img src={gallery8} alt="" />
        <img src={gallery9} alt="" />

    </div>

</section>

{/* ================= MASTER PLAN ================= */}

<section className="btg-section btg-masterplan">

    <div className="btg-section__head">

        <p className="btg-eyebrow">
            Site Overview
        </p>

        <h2>
            A Community Planned Around
            Greens And Open Spaces.
        </h2>

    </div>

    <div className="btg-masterplan__image">

        <img
            src={masterPlan}
            alt="Master Plan"
        />

    </div>

</section>

{/* ================= VILLA TYPES ================= */}

<section className="btg-section btg-section--soft">

    <div className="btg-section__head">

        <p className="btg-eyebrow">
            Villa Options
        </p>

        <h2>
            Choose A Villa
            That Fits
            Your Lifestyle.
        </h2>

    </div>

    <div className="btg-plans">

        <article className="btg-plan">

            <span>01</span>

            <h3>
                4 BHK West
            </h3>

            <p>
                Saleable Area
            </p>

            <strong>
                3701 Sq. Ft.
            </strong>

        </article>

        <article className="btg-plan">

            <span>02</span>

            <h3>
                4 BHK West
                With Backyard
            </h3>

            <p>
                Saleable Area
            </p>

            <strong>
                3471 Sq. Ft.
            </strong>

        </article>

        <article className="btg-plan">

            <span>03</span>

            <h3>
                4 BHK East
            </h3>

            <p>
                Saleable Area
            </p>

            <strong>
                3701 Sq. Ft.
            </strong>

        </article>

        <article className="btg-plan">

            <span>04</span>

            <h3>
                4 BHK East
                With Backyard
            </h3>

            <p>
                Saleable Area
            </p>

            <strong>
                3855 Sq. Ft.
            </strong>

        </article>

        <article className="btg-plan">

            <span>05</span>

            <h3>
                4 BHK North
                With Backyard
            </h3>

            <p>
                Saleable Area
            </p>

            <strong>
                3857 Sq. Ft.
            </strong>

        </article>

    </div>

</section>

{/* ================= AMENITIES ================= */}

<section className="btg-section">

    <div className="btg-section__head">

        <p className="btg-eyebrow">
            Amenities
        </p>

        <h2>
            Designed For Wellness,
            Community And
            Everyday Leisure.
        </h2>

    </div>

    <div className="btg-amenities">

        <div>Therapeutic Path</div>
        <div>Community Lawn</div>
        <div>Golf Mini Putting</div>
        <div>Swimming Pool</div>
        <div>Multi Purpose Court</div>

        <div>Walking Trail</div>
        <div>Club House</div>
        <div>Amphitheatre</div>
        <div>Swing Pad</div>
        <div>Bonfire Court</div>

        <div>Pet Park</div>
        <div>Fragrance Garden</div>
        <div>Outdoor Gym</div>
        <div>Toddler Play Area</div>
        <div>Indoor Games</div>

    </div>

</section>

{/* ================= SPECIFICATIONS ================= */}

<section className="btg-section btg-section--soft">

    <div className="btg-section__head">

        <p className="btg-eyebrow">
            Specifications
        </p>

        <h2>
            Premium Finishes
            For A Refined
            Villa Experience.
        </h2>

    </div>

    <div className="btg-specs">

        <div>
            <h3>Structure</h3>
            <p>RCC framed structure with solid block walls.</p>
        </div>

        <div>
            <h3>Flooring</h3>
            <p>Italian marble and premium vitrified flooring.</p>
        </div>

        <div>
            <h3>Doors & Windows</h3>
            <p>Premium wooden doors with Tostem aluminium windows.</p>
        </div>

        <div>
            <h3>Kitchen</h3>
            <p>Granite countertop with refined kitchen planning.</p>
        </div>

        <div>
            <h3>Bathroom</h3>
            <p>Kohler / Toto sanitary fittings.</p>
        </div>

        <div>
            <h3>Smart Features</h3>
            <p>Smart home controls and digital access.</p>
        </div>

        <div>
            <h3>Power Backup</h3>
            <p>100% DG backup for essential loads.</p>
        </div>

        <div>
            <h3>Security</h3>
            <p>CCTV surveillance with visitor management.</p>
        </div>

    </div>

</section>

{/* ================= LOCATION ================= */}

<section className="btg-section btg-location">

    <div className="btg-location__image">

        <img
            src={locationMap}
            alt="Location"
        />

    </div>

    <div className="btg-location__content">

        <p className="btg-eyebrow">
            Location Advantage
        </p>

        <h2>

            Connected To Whitefield,
            IT Hubs And
            Everyday Essentials.

        </h2>

        <ul>

            <li>Close To Whitefield Tech Hubs</li>
            <li>Access To ITPL, Wipro & Cisco</li>
            <li>Near Greenwood & VIBGYOR Schools</li>
            <li>Connectivity To Outer Ring Road</li>
            <li>Upcoming Metro Connectivity</li>
            <li>Airport Road Access</li>

        </ul>

        <a
            href="tel:+919243024730"
            className="btg-btn btg-btn--dark"
        >

            Call Asset Makers

        </a>

    </div>

</section>

{/* ================= RERA ================= */}

<section className="btg-rera">

    <div>

        <span>
            Asset Makers RERA No.
        </span>

        <strong>
            PRM/KA/RERA/1251/446/AG/230427/003604
        </strong>

    </div>

    <div>

        <span>
            Between The Greens RERA No.
        </span>

        <strong>
            PRM/KA/RERA/1251/308/PR/120225/007494
        </strong>

    </div>

</section>

{/* ================= FOOTER ================= */}

<footer className="btg-footer">

    <div className="btg-footer__left">

        <div className="btg-footer__logos">

            <img
                src={logo}
                alt="BTG"
            />

            <img
                src={assetLogo}
                alt="Asset Makers"
            />

        </div>

        <p>

            Asset Makers is an authorized
            channel partner for Between The Greens.

            Images, specifications,
            pricing and availability are subject
            to change without prior notice.

            Kindly verify all information before
            making any purchase decision.

        </p>

    </div>

    <div className="btg-footer__right">

        <a href="tel:+919243024730">

            +91 92430 24730

        </a>

        <p>

            <strong>
                Between The Greens
            </strong>

            <br />

            Off Whitefield

            <br />

            Bengaluru,
            Karnataka

        </p>

    </div>

</footer>

    </main>
  );
};

export default Btg;